import CallApp from "callapp-lib";
import { CallappOptions } from "node_modules/callapp-lib/dist/type/types";
import { utils } from "msb-public-library";

const options: CallappOptions = {
  scheme: {
    protocol: "artvideowb"
  },
  // intent: {
  //   package: 'com.meishubao.artaiclass',
  //   scheme: 'artaiclass'
  // },

  appstore: "itms-appss://apps.apple.com/cn/app/id1362507427",
  yingyongbao: "https://a.app.qq.com/o/simple.jsp?pkgname=com.yiqi.onetoone",
  fallback: `${location.origin}/1v1h5pages/activity/evokeapp`,
  timeout: 10000
};

const callApp = new CallApp(options);

export function openApp(
  params: {
    /** 唤起类型 h5 | native */
    type: string;
    /** 唤起地址 h5 为完整 url | native 为页面key */
    url: string;
    [key: string]: string;
  },
  fallback?: boolean | undefined
) {
  callApp.open({
    path: "data",
    param: {
      ...params
    },
    callback: fallback
      ? () => callApp.fallToFbUrl()
      : () => goDownload("h5", location.href)
  });
}

export function goDownload(type: string, url: string) {
  if (utils.client.ios) {
    window.location.href = options.appstore;
  } else {
    window.location.href = callApp.generateYingYongBao({
      path: "data",
      param: {
        type: type,
        url: url
      }
    });
  }
}
